import { render } from "./TestEmailPages.vue?vue&type=template&id=b8911762"
import script from "./TestEmailPages.vue?vue&type=script&lang=js"
export * from "./TestEmailPages.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__